// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1979":"2e4119d5","4881":"2e4119d5","6595":"2e4119d5"}[chunkId] + ".chunk.css";
};